import React from 'react';
import { UtensilsCrossed } from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const resolvePhotoUrl = (url) => (url && url.startsWith('/') ? `${BACKEND}${url}` : url);

export const PreorderPhoto = ({ url, alt, size = 'h-14 w-14', testId }) => (
  url ? (
    <img src={resolvePhotoUrl(url)} alt={alt} loading="lazy" data-testid={testId}
      className={`${size} flex-shrink-0 rounded-lg object-cover border border-border-light bg-background`} />
  ) : (
    <div data-testid={testId ? `${testId}-placeholder` : undefined}
      className={`${size} flex-shrink-0 rounded-lg border border-dashed border-border-light bg-background flex items-center justify-center text-text-muted`}>
      <UtensilsCrossed className="h-5 w-5 opacity-50" />
    </div>
  )
);
